var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"text-center",style:(_vm.style)},[_c('v-icon',{attrs:{"size":"39"}},[_vm._v("$vuetify.icons.infoCustom")]),_c('p',{staticClass:"body-1 font-weight-bold mb-0 mt-6 mx-auto"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }